export default __webpack_public_path__ + "static/media/menu-down.4b630873.svg";